import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import zhCommon from './locales/zh-CN/common.json';
import enCommon from './locales/en/common.json';
import zhPublic from './locales/zh-CN/public.json';
import enPublic from './locales/en/public.json';
import zhAdmin from './locales/zh-CN/admin.json';
import enAdmin from './locales/en/admin.json';

export type Language = 'zh-CN' | 'en';
export const LANGUAGE_STORAGE_KEY = 'aviation-calendar-language';

export function initialLanguage(): Language {
  try {
    const saved = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (saved === 'zh-CN' || saved === 'en') {
      return saved;
    }
  } catch {
    // Browsers may disable storage; language switching still works for this visit.
  }
  if (typeof navigator !== 'undefined' && !navigator.language.toLowerCase().startsWith('zh')) {
    return 'en';
  }
  return 'zh-CN';
}

export function currentLocale(): Language {
  return (i18n.resolvedLanguage ?? i18n.language ?? 'zh-CN').startsWith('en') ? 'en' : 'zh-CN';
}

function updateDocument() {
  const language = currentLocale();
  if (typeof document !== 'undefined') {
    document.documentElement.lang = language;
    document.title = i18n.t('common:siteTitle');
  }
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  } catch {
    // A blocked preference store must not prevent use of the calendar.
  }
}

void i18n.use(initReactI18next).init({
  lng: initialLanguage(),
  fallbackLng: 'zh-CN',
  supportedLngs: ['zh-CN', 'en'],
  defaultNS: 'common',
  resources: {
    'zh-CN': { common: zhCommon, public: zhPublic, admin: zhAdmin },
    en: { common: enCommon, public: enPublic, admin: enAdmin },
  },
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
}).then(updateDocument);
i18n.on('languageChanged', updateDocument);

export default i18n;
